import { useMutation } from '@apollo/client';
import { useActiveDocument } from 'shared/domains/documents';
import { REQUEST_REVIEW_MUTATION } from './mutation';
import { GET_REVIEW_QUERY } from '../useCurrentReview';
export function useRequestReview() {
    const { id: documentId } = useActiveDocument();
    const [mutate, { loading }] = useMutation(REQUEST_REVIEW_MUTATION);
    const handler = () => mutate({
        variables: { documentId },
        refetchQueries: [GET_REVIEW_QUERY],
        onQueryUpdated(observableQuery) {
            return observableQuery.refetch();
        },
    });
    return {
        requestReview: handler,
        loading,
    };
}
